import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { OptionalItemsResponse } from '~/core/models/optional-items-response';

const optionalItemsService = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOptionalItems: builder.query<
      OptionalItemsResponse,
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.OPTIONAL_ITEMS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useFetchOptionalItemsQuery } = optionalItemsService;
